import { render } from "./addEditClientEventTemplate.vue?vue&type=template&id=f57e4b9c"
import script from "./addEditClientEventTemplate.vue?vue&type=script&lang=js"
export * from "./addEditClientEventTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__